import { z } from 'zod';

/** Body of every non-2xx response from the panel API. */
export const ApiErrorBodySchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    requestId: z.string().optional(),
    details: z.unknown().optional(),
  }),
});
export type ApiErrorBody = z.infer<typeof ApiErrorBodySchema>;

export const ERROR_LEVELS = ['warn', 'error', 'fatal'] as const;
export type ErrorLevel = (typeof ERROR_LEVELS)[number];

export const ERROR_SOURCES = ['api', 'job', 'web', 'atlas_client', 'email', 'process'] as const;
export type ErrorSource = (typeof ERROR_SOURCES)[number];

/** What the browser sends to `POST /api/client-errors`. Capped so a loop cannot flood the table. */
export const ClientErrorReportSchema = z.object({
  kind: z.enum(['window_error', 'unhandled_rejection', 'react_boundary', 'query', 'mutation']),
  message: z.string().min(1).max(2000),
  stack: z.string().max(10_000).optional(),
  componentStack: z.string().max(10_000).optional(),
  url: z.string().max(2000),
  route: z.string().max(500).optional(),
  requestId: z.string().max(100).optional(),
  appVersion: z.string().max(100).optional(),
  context: z.record(z.string(), z.unknown()).optional(),
});
export type ClientErrorReport = z.infer<typeof ClientErrorReportSchema>;
